import { gql } from "@apollo/client";

export const GET_INTERNAL_PROFILE = gql`
  query InternalProfile {
    internalProfile {
      id
      name
      userName
      canManageSystemUser
      branches
      roleName
      userType
      sideNavigation {
        id
        name
        route
        order
        icon
        roleType
        parentId
        description
        requireAttention
      }
    }
  }
`;
